import { decode } from "js-base64"
import { paramCase } from "param-case"
import { parse, format } from "date-fns"

export default (pageContext, metaData, facilityInfo) => {
  const imgId = JSON.parse(
    decode(pageContext.bannerImage.asset.source.id)
  ).public_id

  const date = format(
    new Date(parse(pageContext.date, "EEEE, MMMM do, yyyy", new Date())),
    "yyyy-MM-dd"
  )

  return {
    "@context": "https://schema.org",
    "@type": "Article",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": paramCase(pageContext.title),
    },
    headline: pageContext.title,
    description: pageContext.summary,
    image: `https://res.cloudinary.com/agoraservices/q_auto,f_auto/${imgId}`,
    author: {
      "@type": "Person",
      name: `${facilityInfo.facilityName} Staff`,
    },
    publisher: {
      "@type": "Organization",
      name: facilityInfo.facilityName,
      image: `https://res.cloudinary.com/agoraservices/q_auto,f_auto/${metaData.logoImgId}`,
      logo: {
        "@type": "ImageObject",
        url: `https://res.cloudinary.com/agoraservices/q_auto,f_auto/${metaData.logoImgId}`,
      },
      telephone: facilityInfo.phone,
      address: {
        "@type": "PostalAddress",
        streetAddress: facilityInfo.streetAddress,
        addressLocality: facilityInfo.city,
        addressRegion: facilityInfo.state,
        postalCode: facilityInfo.zip,
        addressCountry: "US",
      },
    },
    datePublished: date,
    dateModified: pageContext._updatedAt,
  }
}
